var exports = {
  "rv": "KeybindHint.module__tooltipContent___NXROSU",
  "Pf": "KeybindHint.module__label___NXROSU",
  "g": "KeybindHint.module__keybindHint___NXROSU",
  "Eb": "KeybindHint.module__key___NXROSU",
  "WK": "KeybindHint.module__keySymbol___NXROSU" + " " + "KeybindHint.module__key___NXROSU",
};

module.exports = exports;
